import { ClientKey } from "../config/app-config"
import id24Logo from "../screens/main/images/id24_logo.png"
import ddebtLogo from "../screens/main/images/ddebt_logo.png"
import krungsriLogo from "../screens/main/images/krungsri_logo.png"

export type Theme = {
  topLeftLogo: string
  leftLogo: string
  rightLogo: string
  mainLogo: string
  buttonClass: string
  loginBackground: string
  systemSubtitle: string
  titleClassName: string
  browserTitle: string
  favicon: string
  showTopLeftLogo: boolean
}

export const themeByClientKey = (clientKey: ClientKey): Theme => {
  return clientKey === ClientKey.GsbDdebt
    ? {
        topLeftLogo: "logo-gsb-ddebt",
        leftLogo: "logo-small-gsb",
        rightLogo: "logo-small-ddebt",
        mainLogo: ddebtLogo,
        buttonClass: "button-gsb",
        loginBackground: "login-bg-gsb",
        systemSubtitle: "ระบบบันทึกข้อมูลสำหรับบริษัทติดตามหนี้",
        titleClassName: "header-gsb-pink",
        browserTitle: "ID24 Console",
        favicon: "/ddebt_logo.png",
        showTopLeftLogo: true,
      }
    : clientKey === ClientKey.Gsb
    ? {
        topLeftLogo: "logo-gsb",
        leftLogo: "logo-small-gsb",
        rightLogo: "logo-small",
        mainLogo: id24Logo,
        buttonClass: "button-gsb",
        loginBackground: "login-bg-gsb",
        systemSubtitle: "",
        titleClassName: "header-gsb-pink",
        browserTitle: "D-Phone Collection",
        favicon: "/osd-icon-v1.png",
        showTopLeftLogo: false,
      }
    : clientKey === ClientKey.Krungsri
    ? {
        topLeftLogo: "logo-krungsri",
        leftLogo: "logo-small-krungsri",
        rightLogo: "logo-small-osd",
        mainLogo: krungsriLogo,
        buttonClass: "button-krungsri",
        loginBackground: "login-bg-krungsri",
        systemSubtitle: "",
        titleClassName: "header-krungsri-black",
        browserTitle: "ID24 Console",
        favicon: "/osd-icon-v1.png",
        showTopLeftLogo: false,
      }
    : {
        topLeftLogo: "logo-osd",
        leftLogo: "logo-small-osd",
        rightLogo: "logo-small",
        mainLogo: id24Logo,
        buttonClass: "button-osd",
        loginBackground: "login-bg-osd",
        systemSubtitle: "",
        titleClassName: "header-gsb-osd",
        browserTitle: "ID24 Console",
        favicon: "/osd-icon-v1.png",
        showTopLeftLogo: false,
      }
}
